<template>
  <main>
    <background-wrapper :src="routeNameKebab + '/fullscreen-image_hero'" ext="png" align="top">
      <div class="hero">
        <text-container align-center justify-center>
          <h1 class="hero__title">
            <span class="font-weight-normal">{{$t(`${$route.name}.hero.title`)}}</span>
            <br/>
            <span class="hero__title-variant" v-html="$t(`${$route.name}.hero.title-variants.${titleVariantIndex + 1}`)" />
            <br/>
            <span class="font-weight-normal">{{$t(`${$route.name}.hero.title-2`)}}</span>
          </h1>
        </text-container>
      </div>
    </background-wrapper>
    <div class="hr-downloads-is-built">
      <text-container align-center justify-center>
        <h2 h2 class="h1 mb-6" style="max-width: 1100px;" v-html="$t(`${$route.name}.hr-downloads-is-built.title`)" />
        <b-row class="mb-6" style="max-width: 1100px;" align-v="center">
          <b-col cols="12" lg="7" order-lg="1">
            <p class="h-sub text-left smaller-text" v-html="$t(`${$route.name}.hr-downloads-is-built.text-1`)" />
          </b-col>
          <b-col cols="12" lg="5" order-lg="1">
            <div class="hr-downloads-is-built__image-1">
              <img :src="require(`@/assets/${routeNameKebab}/hr-downloads-is-built_1.png`)"/>
            </div>
          </b-col>
        </b-row>
        <b-row style="max-width: 1100px;" align-v="center">
          <b-col cols="12" lg="7" order-lg="3">
            <p class="h-sub text-left smaller-text" v-html="$t(`${$route.name}.hr-downloads-is-built.text-2`)" />
          </b-col>
          <b-col cols="12" lg="5" order-lg="2">
            <div class="hr-downloads-is-built__image-2">
              <img :src="require(`@/assets/${routeNameKebab}/hr-downloads-is-built_2.png`)"/>
            </div>
          </b-col>
        </b-row>
      </text-container>
    </div>
    <background-wrapper :src="routeNameKebab + '/fullscreen-image_our-awards'" ext="png">
      <div class="our-awards">
        <h2 class="h1 text-center mb-0">{{$t(`${$route.name}.our-awards`)}}</h2>
        <b-row align-v="center">
          <b-col cols="12" lg="6">
            <b-row align-v="center" align-h="between" class="mt-5">
              <b-col v-for="n in 4" :key="n" align="center">
                <img :src="require(`@/assets/${routeNameKebab}/our-awards_${n}.png`)">
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" lg="6">
            <b-row align-v="center" align-h="between" class="mt-5">
              <b-col v-for="n in 5" :key="n+4" align="center">
                <img :src="require(`@/assets/${routeNameKebab}/our-awards_${n+4}.png`)">
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </background-wrapper>
    <div class="meet-our-executive-team">
      <h2 h2 class="h1 text-center mb-6 mb-sm-4">{{$t(`${$route.name}.meet-our-executive-team.title`)}}</h2>
      <b-row align-h="center">
        <b-col class="mt-3" cols="6" sm="4" md="3" v-for="n in 4" :key="n" align="center">
          <img class="meet-our-executive-team__image" :src="require(`@/assets/${routeNameKebab}/meet-our-executive-team_${n}.png`)"/>
          <div class="teammate-info">
            <h3 class="h4 mb-1">{{$t(`${$route.name}.meet-our-executive-team.items.${n}.title`)}}</h3>
            <p class="">{{$t(`${$route.name}.meet-our-executive-team.items.${n}.subtitle`)}}</p>
          </div>
        </b-col>
      </b-row>
    </div>
    <div class="get-to-the-management-team">
      <h2 h2 class="h1 text-center mb-6 mb-sm-4">{{$t(`${$route.name}.get-to-the-management-team.title`)}}</h2>
      <b-row align-h="center">
        <b-col class="mt-3" cols="6" sm="4" md="3" v-for="n in managementTeamIndex" v-bind:key="n" align="center">
          <img class="get-to-the-management-team__image" :src="require(`@/assets/${routeNameKebab}/get-to-the-management-team_${n}.png`)"/>
          <div class="teammate-info">
            <h3 class="h4 mb-1">{{$t(`${$route.name}.get-to-the-management-team.items.${n}.title`)}}</h3>
            <p class="">{{$t(`${$route.name}.get-to-the-management-team.items.${n}.subtitle`)}}</p>
          </div>
        </b-col>
      </b-row>
    </div>
    <background-wrapper :src="routeNameKebab + '/fullscreen-image_interested-in-becoming-a-partner'" ext="png">
      <div class="interested-in-becoming-a-partner">
        <text-container size="lg" align-center justify-center>
          <h2 h2 class="h1 text-center" v-html="$t(`${$route.name}.interested-in-becoming-a-partner.title`)" />
          <p class="h-sub">{{$t(`${$route.name}.interested-in-becoming-a-partner.subtitle`)}}</p>
        </text-container>
        <div class="interested-in-becoming-a-partner__slider">
          <VueSlickCarousel :arrows="true" v-bind="settings" ref="partners">
            <div v-for="n in 20" :key="n">
              <a :href="$t(`${$route.name}.partner-links.partner-${n}`)" class="interested-in-becoming-a-partner__image">
                <img :src="require(`@/assets/${routeNameKebab}/partners/partner_${n}.png`)"/>
              </a>
            </div>
            <template #prevArrow>
              <div class="custom-arrow">
                <img src="@/assets/arrow-left.svg">
              </div>
            </template>
            <template #nextArrow>
              <div class="custom-arrow">
                <img src="@/assets/arrow-right.svg">
              </div>
            </template>
          </VueSlickCarousel>
        </div>
        <div class="text-center">
          <b-btn variant="primary" to="/become-a-partner">{{$t('learn-more')}}</b-btn>
        </div>
      </div>
    </background-wrapper>
  </main>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  name: 'AboutUs',
  mounted () {
    setInterval(() => {
      this.titleVariantIndex = (this.titleVariantIndex + 1) % this.titleVariantCount
      if (this.$refs.partners) {
        this.$refs.partners.next()
      }
    }, 1500)
  },
  data () {
    return {
      managementTeamIndex: [1, 4, 5, 6, 7, 8, 9],
      titleVariantIndex: 0,
      titleVariantCount: 8,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 2000,
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 4
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2
            }
          }
        ]
      }
    }
  },
  computed: {
    routeNameKebab: app => app.$toKebabCase(app.$route.name)
  },
  components: { VueSlickCarousel }
}
</script>

<style lang="sass" scoped>
img
  max-width: 100%
  width: 100%

.hero
  padding: 180px 0
  height: 840px
  display: flex
  align-items: center
  +media-breakpoint-up(md)
    justify-content: center
  +media-breakpoint-down(lg)
    padding: 220px 0 180px
    height: 750px
  +media-breakpoint-down(md)
    padding: 280px 0 100px
    height: 680px
  +media-breakpoint-down(sm)
    height: 800px
  +media-breakpoint-only(sm)
    margin: 0 calc((600px - 100vw) / 4)
  +media-breakpoint-down(xs)
    height: 600px
  +media-breakpoint-down(xxs)
    height: 400px

  &__title
    margin: 0
    font-size: 80px
    text-transform: uppercase
    +media-breakpoint-down(sm)
      text-align: left
      font-size: 60px
    +media-breakpoint-down(xs)
      font-size: 50px
    +media-breakpoint-down(xxs)
      font-size: 40px

    &-variant
      display: inline-block
      padding: 0 10px
      background-color: #FFE451
      font-weight: 700
      line-height: 1.2
      +media-breakpoint-down(sm)
        display: inline
        padding: 0

.hr-downloads-is-built
  margin: 100px 0 190px
  +media-breakpoint-only(xs)
    padding: 0 40px

  .h-sub
    margin-bottom: 0!important
    &.smaller-text
      font-size: 20px
    +media-breakpoint-down(md)
      margin-bottom: 3rem!important

  &__image-1
    margin: -60px -90px 0 0
    +media-breakpoint-down(sm)
      margin: -60px -60px 0 0

  &__image-2
    margin: 0 0 -60px -60px
    +media-breakpoint-down(sm)
      margin: 0 0 -60px -30px

.our-awards
  margin-bottom: -120px
  padding-bottom: 610px
  @media screen and (min-width: 2000px)
    padding-top: calc((100vw - 2000px)/6)
    padding-bottom: calc((100vw - 2000px)/6 + 610px)
  +media-breakpoint-down(lg)
    padding-bottom: 380px
  +media-breakpoint-down(md)
    padding-bottom: 350px
  +media-breakpoint-down(sm)
    margin-top: -100px
    margin-bottom: 30px
    padding-bottom: 390px
  +media-breakpoint-down(xs)
    padding-bottom: 285px

  img
    max-height: 100px
    width: auto
    min-width: 50px

.meet-our-executive-team,
.get-to-the-management-team
  margin-bottom: 100px
  +media-breakpoint-down(sm)
    margin-bottom: 80px
  +media-breakpoint-only(xs)
    padding: 0 40px

  &__image
    max-width: 100%
    +media-breakpoint-down(xs)
      max-width: 200px

  .teammate-info
    margin-top: 20px
    max-width: 320px
    text-align: left

    p
      color: #383B41

.interested-in-becoming-a-partner
  padding: 70px 0 170px
  @media screen and (min-width: 2000px)
    padding-top: calc((100vw - 2000px)/6 + 70px)
    padding-bottom: calc((100vw - 2000px)/6 + 170px)
  +media-breakpoint-down(md)
    padding: 0 0 80px
  +media-breakpoint-down(sm)
    padding: 0 0 100px
  +media-breakpoint-down(xs)
    padding: 0 0 120px

  &__image
    display: flex
    align-items: center
    justify-content: center
    padding: 0 20px
    height: 70px
    width: 100%

    img
      max-height: 100%
      width: auto

  &__slider
    margin: 40px auto 80px
    padding: 0 40px
    max-width: 1000px

  .custom-arrow
    color: $dark
    font-size: 14px
    height: 29px
    &:before
      content: none
</style>



// WEBPACK FOOTER //
// src/components/aboutUs/AboutUs.vue